//German
const messages = {
};
module.exports = messages;
